import { ColSize } from "antd/lib/col";


declare type ColSpanType = ColSize;

export const InputColLayout: { [key: string]: ColSpanType } = {
    xs: { span: 22, },
    sm: { span: 22, },
    md: { span: 22, },
    lg: { span: 10, },
    xl: { span: 10, },
};

export const ButtonColLayout: { [key: string]: ColSpanType } = {
    xs: { span: 1, offset: 4 },
    sm: { span: 1, offset: 4 },
    md: { span: 1, offset: 7 },
    lg: { span: 1, offset: 7 },
    xl: { span: 1, offset: 7 },
};